<template>
  <div class="h-screen rounded-lg flex flex-col gap-2 w-full">
    <div class="flex justify-end items-center gap-2">
      <AppSearch />
      <AppNotification />
      <AppProfileSearch />
    </div>
    <ConfirmComponent
      v-if="showConfirmDialog"
      :message="confirmMessage"
      @confirm="handleConfirm"
      @cancel="handleCancel"
    />
    <div
      class="flex flex-col gap-2 overflow-y-auto scrollbar-thin scrollbar-orange"
    >
      <div class="w-full">
        <AppTable
          :visibility="this.validPermission('V0002')"
          :show="show_table"
          :table_data="ordens"
          :table_title="table_title"
          :hiddenHeaders="hiddenHeaders"
          :aplyRowHeight="true"
          @row-clicked="select_ordem"
          @close="close_table"
          @delete_data="remove_viatura"
        />
      </div>
      <AddressMap
        v-if="true"
        :initialAddress="{ id: 0, pais: '' }"
        @close="null"
        @save="null"
        multiplePin_mode="true"
        :multiplePin_data="addressCoordinates"
        @save_multiPins="set_multiplePins"
      />
    </div>
  </div>
</template>
<script>
import permissionMixin from "@/permissionMixin.js";
import AppTable from "@/components/tables/table.vue";
import AppProfileSearch from "@/components/profileSearch.vue";
import AppSearch from "@/components/search.vue";
import AppNotification from "@/components/notification.vue";
import AppButton from "@/components/updated/button.vue";
import axios from "axios";
import { getUser } from "@/extraData";
import ConfirmComponent from "@/components/modals/ConfirmComponent.vue";
import { toast } from "vue3-toastify";
import AddressMap from "@/components/addressMap.vue";
import { da } from "date-fns/locale";

export default {
  mixins: [permissionMixin],
  name: "appAgednar",
  components: {
    AppTable,
    AppProfileSearch,
    AppSearch,
    AppNotification,
    AppButton,
    ConfirmComponent,
    AddressMap,
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_URL_BASE,
      showSidebar: true,
      show_table: true,
      ordens: [],
      table_title: "Serviços",
      loggedId: getUser().id,
      showConfirmDialog: false,
      confirmMessage: "Quer começar este serviço?",
      nextRoute: null,
      goItems: true,
      selectedOrdem: null,
      ordemCoordinates: [],
      locais: [],
      addressCoordinates: [],
      hiddenHeaders: ["id"],
    };
  },
  methods: {
    async create(data, url) {
      try {
        const res = await axios.post(url, data);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async select(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async select_all(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async update(url, data) {
      try {
        const res = await axios.put(url, data);
        console.log("Data successfully updated:", res.data);
        return true;
      } catch (error) {
        console.error("Error posting data:", error);
      }
    },
    async remove(url) {
      // console.log("Data:", data.id)
      try {
        await axios.delete(url);
        return true;
      } catch (error) {
        console.error("Error deleting data:", error);
      }
    },
    async getOrdensServico() {
      const res = await this.select_all(
        `${this.baseURL}/api/v1/ordemservico/utilizador/${this.loggedId}/`
      );
      if (res) {
        this.ordens = res.filter((ordem) =>
          ["transferido", "execução", "interrompido"].includes(ordem.status)
        );
        const locais = this.ordens.map((ordem) => {
          return {
            id: ordem.localInstalacao.id,
            nome: ordem.localInstalacao.nome,
          };
        });
        // Use Promise.all to wait for all the asynchronous operations to complete
        this.locais = await Promise.all(
          locais.map(async (local) => {
            return await this.select(
              `${this.baseURL}/api/v1/localinstalacao/${local.id}/`
            );
          })
        );
        this.addressCoordinates = this.locais.map((local) => {
          return {
            id: local.endereco?.id || 0,
            latitude: local.endereco?.latitude || 0,
            longitude: local.endereco?.longitude || 0,
            highlight: false,
          };
        });

        console.log("Locais:", this.locais);
        console.log("Address Coordinates:", this.addressCoordinates);
      }
    },
    async updateOrdemServico(status, ordemId, date) {
      const data = {
        status: status,
        data_inicio: date,
      };
      const res = await this.update(
        `${this.baseURL}/api/v1/ordemservico/editar/${this.selectedOrdem.id}/`,
        data
      );
      if (res && this.goItems) {
        // toast.success("Serviço começado com sucesso");
        this.$router.push({
        name: "execucoes",
        params: { order_id: this.selectedOrdem.id }
        });
      } else {
        toast.error("Erro ao começar o serviço");
        this.showConfirmDialog = false;
      }
    },
    getMessage(status) {
      if (status === "transferido") {
        return "Quer começar este serviço?";
      } else if (status === "interrompido") {
        return "Quer continuar este serviço?";
      } else if (status === "execução") {
        return "Deseja entrar neste serviço?";
      }
    },
    async select_ordem(data) {
      this.selectedOrdem = data;
      this.confirmMessage = this.getMessage(data.status);
      this.showConfirmDialog = true;
      console.log("Selected ordem:", data);
      const local = await this.select(
        `${this.baseURL}/api/v1/localinstalacao/${data.localInstalacao.id}/`
      );
      if (local) {
        this.addressCoordinates.map((address) => {
          if (address.id === local.endereco.id) {
            address.highlight = true;
          } else {
            address.highlight = false;
          }
        });
      }

      // this.$router.push({ name: 'execucoes', params: { order_id: data.id } });
    },
    handleConfirm() {
      const date = new Date().toISOString();
      this.updateOrdemServico("execução", this.selectedOrdem.id, date);
    },
    handleCancel() {
      this.showConfirmDialog = false;
    },

    async set_multiplePins(data) {
      console.log("Multiple pins data:", data);
      const updated_addresses = await Promise.all(
        data.map(async (address) => {
          return await this.update(
            `${this.baseURL}/api/v1/endereco/editar/${address.id}/`,
            {
              latitude: address.lat,
              longitude: address.lng,
            }
          );
        })
      );

      if (updated_addresses) {
        toast.success("endereço atualizado com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      }
    },
  },

  created() {
    this.getOrdensServico();
  },
};
</script>
